/**
 * Arche wrapper for Image Editor — full-screen editor by default.
 */

import { EditorPage } from './EditorPage';

export function ImageEditorArchePage() {
  return <EditorPage />;
}
